import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import HealthCenterScheduleBody from "components/ClinicalManagement/HealthCenters/Details/HealthCenterSchedule/ScheduleBody/HealthCenterScheduleBody";

const HealthCenterSchedule = () => {
  useEffect(() => {
    document.title = "Schedule";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <HealthCenterScheduleBody />
    </main>
  );
};

export default HealthCenterSchedule;
